import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { AuditTimeline } from '@/components/audit-timeline';
import { Pagination } from '@/components/pagination';
import { Card, CardContent } from '@/components/ui/card';
import { historyQuery } from '@/features/forms/api';

export const Route = createFileRoute('/_app/runs/$runId/activity')({
  component: RunActivity,
});

function RunActivity() {
  const { runId } = Route.useParams();
  const [page, setPage] = useState(1);
  const history = useQuery(historyQuery('run', runId, page));
  return (
    <Card>
      <CardContent>
        {history.data ? (
          <>
            <AuditTimeline entries={history.data.history} />
            <Pagination info={history.data} onPageChange={setPage} className="mt-6" />
          </>
        ) : (
          <p className="text-sm text-muted-foreground">Loading…</p>
        )}
      </CardContent>
    </Card>
  );
}
